import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Lohnt sich eine Photovoltaik-Anlage in der Schweiz 2026?",
    a: "Für die meisten Eigenheim­besitzer ja. Bei Schweizer Strompreisen von rund 32 Rp./kWh und attraktiven Förderungen (Pronovo + Kanton) liegt die Amortisations­zeit typischerweise zwischen 8 und 12 Jahren – bei einer Modul-Garantie von 25 Jahren.",
  },
  {
    q: "Wie lange dauert die Installation einer PV-Anlage?",
    a: "Eine durchschnittliche Anlage auf einem Einfamilienhaus ist innert 1–3 Werktagen installiert. Von Vertragsunterschrift bis Inbetriebnahme dauert es typischerweise 2–4 Monate, abhängig von Bewilligungen und Liefer­zeiten der Komponenten.",
  },
  {
    q: "Brauche ich eine Baubewilligung?",
    a: "In den meisten Schweizer Gemeinden sind PV-Anlagen auf dem Dach bewilligungs­frei (Meldepflicht). Bei denkmal­geschützten Bauten oder freistehenden Anlagen kann eine Bewilligung nötig sein. Wir kümmern uns um die Abklärung.",
  },
  {
    q: "Welche Förderungen kann ich erwarten?",
    a: "Der Bund (Pronovo) zahlt eine Einmalvergütung von ca. CHF 350 Grundbeitrag + CHF 400 pro kWp (bis 30 kWp). Viele Kantone und Gemeinden legen drauf. Mit unserem Förder-Check erhalten Sie eine erste Schätzung in unter 30 Sekunden.",
  },
  {
    q: "Was passiert mit dem überschüssigen Strom?",
    a: "Strom, den Sie nicht selbst verbrauchen, wird ins Netz eingespeist und vom lokalen Energie­versorger vergütet (Rückspeise­tarif typischerweise 8–14 Rp./kWh). Mit einem Batterie­speicher oder einer Wallbox erhöhen Sie Ihren Eigenverbrauch deutlich.",
  },
  {
    q: "Wie lange hält eine Solaranlage?",
    a: "Moderne Module haben eine Leistungs­garantie von 25 Jahren (typisch noch 85 % Leistung). Die tatsächliche Lebens­dauer liegt erfahrungs­gemäss bei 30+ Jahren. Wechselrichter werden meist nach 12–15 Jahren einmal ersetzt.",
  },
  {
    q: "Brauche ich zwingend einen Batteriespeicher?",
    a: "Nein – eine PV-Anlage rechnet sich auch ohne Speicher. Ein Speicher ist sinnvoll, wenn Sie maximale Unabhängig­keit wollen, eine Wärmepumpe / E-Auto haben oder Notstrom­funktion wünschen. Wir empfehlen, zuerst die PV-Anlage zu bauen und einen Speicher später nachzurüsten.",
  },
  {
    q: "Was kostet eine durchschnittliche Anlage?",
    a: "Eine schlüsselfertige 10-kWp-Anlage für ein Einfamilienhaus kostet 2026 typischerweise zwischen 20'000 und 26'000 CHF inkl. Montage. Mit Speicher kommen 8'000–12'000 CHF dazu, mit Wallbox weitere 2'000–4'000 CHF. Nach Förderungen liegt die Netto-Investition oft 25–35 % tiefer.",
  },
  {
    q: "Wie funktioniert die Garantie und der Service?",
    a: "Solanova gibt 5 Jahre Werks­garantie auf die Installation. Auf die Komponenten gelten die Hersteller­garantien: Module 25 Jahre Leistungs­garantie, Wechselrichter 10–12 Jahre, Speicher 10 Jahre. Service-Anfragen bearbeiten wir innert 48 Stunden vor Ort.",
  },
  {
    q: "Was muss ich tun, um zu starten?",
    a: "Sehr einfach: Solar-Check ausfüllen (60 Sekunden) oder Kontakt­formular nutzen. Wir melden uns innert 24 Stunden, vereinbaren einen kosten­losen Vor-Ort-Termin und erstellen eine massgeschneiderte Offerte mit Wirtschaftlichkeits­rechnung.",
  },
];

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section bg-[var(--sol-bg)] border-t hairline relative"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <p className="eyebrow">FAQ</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extralight tracking-tight mt-6 text-white leading-[1.05]">
              Häufige <br />
              <span className="bronze-metallic">Fragen.</span>
            </h2>
            <p className="font-body text-white/55 mt-6 text-base leading-relaxed">
              Sie haben eine Frage, die hier nicht beantwortet wird?{" "}
              <a
                href="#kontakt"
                data-testid="faq-contact-link"
                className="link-bronze"
              >
                Schreiben Sie uns
              </a>
              .
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="space-y-3">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="bg-[var(--sol-surface)] border border-white/8 hover:border-[var(--sol-bronze)]/30 rounded-2xl px-6 md:px-8 transition-colors"
                >
                  <AccordionTrigger className="font-display text-left text-base md:text-lg text-white font-light py-5 hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="font-body text-white/65 leading-relaxed pb-5 text-sm md:text-base">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
